<template>
    <label class="file-select">
        <div class="select-button">
            <span><v-icon class="white--text">cloud_upload</v-icon>{{label}}</span>
            <br>
            <small style="direction: rtl" v-if="width > 0">
                ({{toPersianDigit(width)}}px عرض
                ×
                {{toPersianDigit(height)}}px ارتفاع)
            </small>
            <small style="direction: ltr" v-if="maxSize > 0">(حداکثر حجم {{maxSize}}kb‍)</small>
            <small style="direction: ltr" v-if="format.length > 0">فرمت {{format}}</small>
            <br>
            <img
                    v-if="src.length > 0"
                    :src="src"
                    style="max-width: 80%;max-height: 320px"
            >
            <br>
            <span v-if="value">فایل انتخابی: {{value.name}}</span>
        </div>
        <input type="file" @change="handleFileChange"/>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </label>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  props: {
    value: File,
    format: {
      type: String,
      default: 'png'
    },
    label: {
      type: String,
      default: 'فایلی برگزینید'
    },
    defaultSrc: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 32
    },
    width: {
      type: Number,
      default: 32
    },
    maxSize: {
      type: Number,
      default: 100
    },
    aspectRatio: {
      type: Boolean,
      default: false
    },
    sizeForced: {
      type: Boolean,
      default: false
    },
    sizeMin: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      progress: 0,
      src: '',
      base_image_width: 0,
      base_image_height: 0,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
    };
  },
  watch: {
    defaultSrc: function () {
      this.src = this.defaultSrc;
    }
  },
  mounted: function () {
    this.src = this.defaultSrc;
  },
  methods: {
    handleFileChange (e) {
      if (e.target.files[0] === undefined) {
        this.snackbar.text = 'فایلی دریافت نشد!';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        return;
      }
      let sp = e.target.files[0].name.split('.');
      let formats = this.format.split(',');
      if (formats.indexOf(sp[sp.length - 1]) === -1) {
        this.snackbar.text = 'فرمت تصویر مجاز نمیباشد.';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        return;
      }
      if (this.maxSize > 0 && e.target.files[0].size > (this.maxSize * 1024)) {
        this.snackbar.text = 'حجم فایل بزرگتر از ' + (this.maxSize) + ' کیوبایت است.';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        return;
      }
      let reader = new FileReader();
      reader.onload = (event) => {
        let img = new Image();
        img.onload = () => {
          if (this.sizeForced && (img.width !== this.width || img.height !== this.height)) {
            this.snackbar.snackbar = true;
            this.snackbar.text = 'اندازه‌ی تصویر مناسب نیست!';
            this.snackbar.color = 'red';
            return;
          }
          if (this.sizeMin && (img.width < this.width || img.height < this.height)) {
            this.snackbar.snackbar = true;
            this.snackbar.text = 'اندازه‌ی تصویر کوچکتر از ' + this.width + '×' + this.height + ' است!';
            this.snackbar.color = 'red';
            return;
          }
          if (this.aspectRatio && Math.round(img.width / img.height) !== Math.round(this.width / this.height)) {
            this.snackbar.snackbar = true;
            this.snackbar.text = 'تناسب طول و عرض تصویر رعایت نشده است!';
            this.snackbar.color = 'red';
            return;
          }
          this.src = img.src;
          this.$emit('input', e.target.files[0]);
        };
        img.src = event.target.result;
      };
      reader.onerror = () => {
        this.snackbar.text = 'فایل موردنظر قابل پردازش نمیباشد!';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  }
};
</script>

<style scoped>
    .file-select > .select-button {
        padding: 1rem;
        cursor: pointer;
        color: #7a7a7a;
        border: 1px dashed #b6b6b6;
        border-radius: .3rem;
        text-align: center;
        font-weight: bold;
    }
    .file-select > input[type="file"] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageSelect.vue